import { render, staticRenderFns } from "./editorAccountManage.vue?vue&type=template&id=368b2ffe"
import script from "./editorAccountManage.vue?vue&type=script&lang=js"
export * from "./editorAccountManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports